import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  IconButton,
  ListItem,
  TextField,
  Tooltip,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { useEffect, useState } from "react";
import {
  createBioPrefRelation,
  getAttributes,
  getBioPrefRelations,
  updateBioPrefRelation,
  deleteBioPrefRelation
} from "utils/attributesUtil";
import { QuestionResponse } from "models/batch/QuestionResponse";
import { Attribute } from "models/profile/Attribute";
import { BioPrefRelation } from "models/batch/BioPrefRelation";
import { EditableTable } from "components/alove/EditableTable";
import { GridColDef } from "@mui/x-data-grid-pro";
import { useTranslations } from "context";

const MDButton = require("components/MDButton/index.js").default;
const MDTypography = require("components/MDTypography/index.js").default;
const MDInput = require("components/MDInput/index.js").default;

export const RelatedAttributes = (props: { responses: QuestionResponse[]; attrName: string }) => {
  const { responses, attrName } = props;
  const [attributes, setAttributes] = useState([] as Attribute[]);
  const [relatedAttr, setRelatedAttr] = useState({} as Attribute);
  const [relatedQuestions, setRelatedQuestions] = useState([] as Partial<BioPrefRelation>[]);
  const { tr } = useTranslations();

  useEffect(() => {
    if (!attrName) return;
    getAttributes().then((attr) => {
      ;
      setAttributes(attr.filter((a) => a.txt).sort((a, b) => a.txt?.localeCompare(b.txt)));
      
    });
    getBioPrefRelations().then((relations) => {
      if (relations?.length) {
        setRelatedQuestions(relations.
          sort((a, b) => tr(a.prefResponseId)?.localeCompare(tr(b.prefResponseId))).
          filter((r) => r.prefAttrId === attrName));
      } else {
        //   setRelatedQuestions(
        //     responses.map((r) => ({ prefResponseId: r.id, score: 10, pref_attr_id: attrName }))
        //   );
      }
    });
  }, [attrName]);

  useEffect(() => {
    if (!relatedQuestions.length) return;
    setRelatedAttr(attributes.find((a) => a.name === relatedQuestions[0]?.bioAttrId)!);
  },[relatedQuestions, attributes]);

  const columns: GridColDef<BioPrefRelation>[] = [
    {
      field: "prefResponseId",
      headerName: "Pref response",
      flex: 3,
      editable: true,
      valueFormatter: (v) => responses?.find((r) => r.txtId === v)?.txt,

      type: "singleSelect",
      valueOptions: responses?.map((r) => ({ value: r.txtId, label: r.txt })),
    },
    {
      field: "bioResponseId",
      headerName: "Bio response",
      flex: 3,
      editable: true,
      valueFormatter: (v) => relatedAttr?.responses?.find((r) => r.txtId === v)?.txt,

      type: "singleSelect",
      valueOptions: relatedAttr?.responses?.map((r) => ({ value: r.txtId, label: r.txt })),
    },
    { field: "score", headerName: "Score", flex: 1, editable: true, type: "number" },
  ];

  const onRowUpdate = async (newRow: BioPrefRelation, oldRow: BioPrefRelation) => {
    updateBioPrefRelation(newRow as BioPrefRelation)
    return newRow;
  }

  return (
    <Grid container flexDirection={"column"} gap={2}>
      <Grid size={4}>
        <Autocomplete
          options={attributes}
          getOptionLabel={(a) => a.txt || ""}
          getOptionKey={(a) => a.name}
          value={relatedAttr || null}
          onChange={(e, v) => {
            setRelatedAttr(v!);
            setRelatedQuestions([...relatedQuestions]);
          }}
          renderInput={(params) => <TextField {...params} label="Bio attribute" />}
        />
      </Grid>
      <EditableTable
        columns={columns}
        rows={relatedQuestions as any}
        processRowUpdate={onRowUpdate}
        modelName="Relation"
        onAddRow={async (newRow) => {
          newRow.prefAttrId = attrName;
          newRow.bioAttrId = relatedAttr.name;
          await createBioPrefRelation(newRow as BioPrefRelation);
        }}
        onDelRow={async (row) => {
          await deleteBioPrefRelation(row as BioPrefRelation);
        }}
      />
    </Grid>
  );
}